// OrderSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "../../utils/request";

// ✅ إنشاء طلب PayPal
export const insertPayment = createAsyncThunk(
  "posts/insertPayment",
  async (paymentData, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const res = await request.post(
        "https://ssl.vipwellness-suite.de/api/payments/create", // تأكد من أن هذا هو المسار الصحيح
        {
          price: paymentData.price,
          orderId: paymentData.orderId, // إرسال orderId إلى الخادم
        },
        {
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ✅ إنشاء طلب حجز
export const creatOrder = createAsyncThunk(
  "posts/createOrder",
  async (item, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      // تحضير البيانات للإرسال
      const orderData = {
        title: item.title || 'Herr', // إضافة حقل title مع قيمة افتراضية
        name: item.name,
        vorname: item.vorname,
        email: item.email,
        strabe: item.strabe,
        phoneNumber: item.phoneNumber,
        plz: item.plz,
        stadi: item.stadi,
        adultNum: item.adultNum,
        date: item.date,
        startTime: item.startTime,
        endTime: item.endTime,
        hours: item.hours,
        price: item.price,
        payedBy: item.payedBy || 'paypal',
        subCategories: item.subCategories || []
      };

      console.log("Sending to API:", orderData);

      // إرسال البيانات إلى API
      const res = await request.post(
        "https://ssl.vipwellness-suite.de/api/orders", 
        orderData,
        {
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
          },
        }
      );

      console.log("API response:", res.data);
      return res.data;
    } catch (error) {
      console.error("API error:", error.response?.data || error.message);
      return rejectWithValue(error.response?.data?.message || error.message || "Fehler bei der Buchung");
    }
  }
);



// ✅ تأكيد الدفع وتحديث حالة الحجز
export const confirmPayment = createAsyncThunk(
  "posts/confirmPayment",
  async ({ orderId, paymentId }, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const res = await request.patch(
        `https://ssl.vipwellness-suite.de/api/orders/${orderId}`,
        { status: "completed", paymentId },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  order: [],
  records: [],
  Loading: false,
  error: null,
  reco: [],
};

const paySlice = createSlice({
  name: "order",
  initialState,
  extraReducers: (builder) => {
    // ... (ابقاء الـ reducers الحالية كما هي)
    builder.addCase(insertPayment.fulfilled, (state, action) => {
      state.Loading = false;
      state.records.push(action.payload);
    });
    builder.addCase(insertPayment.rejected, (state, action) => {
      state.Loading = false;
      state.error = action.payload;
    });
  },
});

export default paySlice.reducer;
